// extracted by mini-css-extract-plugin
export default {"container":"_PaginatorStyles_container__0kzWn"};